'use strict';
import {
  authFirebase,
  firebaseAuthError,
  firebaseAuthSuccess,
  hydrateProfile,
  lockSuccess,
  logoutError,
  tokenRefreshed,
} from '../actions';

const initialState = {
  profile: null,
  apiToken: null,
  firebaseToken: null,
  isAuthenticated: false,
  userId: null,
  err: null,
};

/**
 * @param {object} state
 * @param {ReduxAction} action
 * @return {*}
 */
export function authData(state = initialState, action) {
  switch (action.type) {
    case hydrateProfile.TYPE:
      return {
        ...state,
        profile: action.payload.profile,
      };
    case tokenRefreshed.TYPE:
      return {
        ...state,
        apiToken: action.payload.token,
      };
    case lockSuccess.TYPE:
      return {
        ...state,
        profile: action.payload.profile,
        apiToken: action.payload.token,
        lock: {
          ...state.lock,
          isFetching: false,
          err: null,
        },
      };
    case authFirebase.TYPE:
      return {
        ...state,
        firebaseToken: action.payload.token,
      };
    case firebaseAuthSuccess.TYPE:
      return {
        ...state,
        userId: action.payload.userId,
        isAuthenticated: true,
      };
    case firebaseAuthError.TYPE:
    case logoutError.TYPE:
      return {
        ...state,
        err: action.payload.err,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/reducers/authData.js